import { ofType } from "redux-observable";
import { catchError, map, mergeMap, of, from, concatMap, tap } from "rxjs";
import {
  renameDocumentRequest,
  renameDocumentSuccess,
  renameDocumentFailure,
  renameLabelRequest,
  renameLabelSuccess,
  renameLabelFailure,
} from "./labelSlice";
import { UploadFileService } from "@/features/upload/services/UploadFileService";
import { FolderService } from "@/services/FolderService";
import { navigationActions } from "@/store/navigation/navigationSlice";
import { trackEvent, ItemAction } from "@/libs/analytics/analyticsEvents";

export const renameLabelEpic = (action$: any) =>
  action$.pipe(
    ofType(renameLabelRequest.type),
    mergeMap((action: any) => {
      const { labelId, newName, currentFolderId, folderRootId } =
        action.payload;
      return from(UploadFileService.Put.renameLabel(labelId, newName)).pipe(
        mergeMap(() => {
          const targetFolderId =
            currentFolderId ||
            folderRootId ||
            localStorage.getItem("folderRootId") ||
            "";
          const apiCall = FolderService.Get.getFilesByFolderId(targetFolderId);
          return from(apiCall).pipe(
            tap(() => {
              trackEvent({
                action: ItemAction.EDIT,
                item_id: labelId,
                item_type: "folder",
                status: "success",
              });
            }),
            concatMap((response) => [
              renameLabelSuccess({ response }),
              navigationActions.updateBreadcrumbName({
                folderId: labelId,
                newName: newName,
              }),
            ])
          );
        }),
        catchError((error) => {
          trackEvent({
            action: ItemAction.EDIT,
            item_id: labelId,
            item_type: "folder",
            status: "fail",
            error_message: error?.message || "Unknown error",
          });
          return of(renameLabelFailure(error?.message || "Rename failed"));
        })
      );
    })
  );

export const renameDocumentEpic = (action$: any) =>
  action$.pipe(
    ofType(renameDocumentRequest.type),
    mergeMap((action: any) => {
      const { id, displayName } = action.payload;
      return from(
        UploadFileService.Patch.updateDocumentDisplayName(id, displayName)
      ).pipe(
        tap(() => {
          trackEvent({
            action: ItemAction.EDIT,
            item_id: id,
            item_type: "file",
            status: "success",
          });
        }),
        map((response) => renameDocumentSuccess({ response })),
        catchError((error) => {
          trackEvent({
            action: ItemAction.EDIT,
            item_id: id,
            item_type: "file",
            status: "fail",
            error_message: error?.message || "Unknown error",
          });
          return of(renameDocumentFailure(error?.message || "Rename failed"));
        })
      );
    })
  );

export const labelEpics = [renameLabelEpic, renameDocumentEpic];
